export default __webpack_public_path__ + "static/media/2.1.dc4d4054.mp4";